module.exports = __webpack_public_path__ + "static/media/sort-alt.b3fc8f80.svg";